import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";

import Unauthorized from "../../ui/components/Unauthorized/Unauthorized";

import useHasRight from "../../authorization/hooks/useHasRight";

import OrganizationsView from "../views/OrganizationsView/OrganizationsView";

export default function Publishers() {
	const { t } = useTranslation();
	const { organization } = useOutletContext();

	const hasRight = useHasRight();

	if (!hasRight("publishers.view")) {
		return <Unauthorized />;
	}

	return <OrganizationsView header={t("publishers", "Publishers")} type="publisher" producer={organization.id} />;
}
